import { SVGProps } from 'react';

const UsersRound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 21a8 8 0 0 0-8-8m0 0a8 8 0 0 0-8 8m8-8a5 5 0 1 0 0-10 5 5 0 0 0 0 10m12 7c0-3.37-2-6.5-4-8a5.002 5.002 0 0 0-.45-8.3"
    />
  </svg>
);
export default UsersRound;
